import { apiPaths } from 'api/kinerja/kepala-sekolah/config'
import { useMutationApi, useQueryApi } from 'utils/api'

import type { UseMutationOptions } from 'react-query'
import type {
  TRequestKirimPenilaianTahunan,
  TRequestListPenilaianTahunan,
  TRequestOverridePenilaianTahunan,
  TRequestPayloadKirimPenilaianTahunan,
  TRequestPayloadOverridePenilaianTahunan,
  TRequestPenilaianTahunanCount,
  TRequestSummaryPenilaianTahunan,
  TResponseKirimPenilaianTahunan,
  TResponseListPenilaianTahunan,
  TResponseOverridePenilaianTahunan,
  TResponsePenilaianTahunanCount,
  TResponseSummaryPenilaianTahunan,
  UQO,
} from 'types/kinerja-dinas-penilaian'

export const API_GET_COUNT_PENILAIAN_TAHUNAN_DINAS_TAB_GURU =
  'API_GET_COUNT_PENILAIAN_TAHUNAN_DINAS_TAB_GURU'

export const API_GET_LIST_PENILAIAN_TAHUNAN_DINAS_TAB_GURU =
  'API_GET_LIST_PENILAIAN_TAHUNAN_DINAS_TAB_GURU'

export const API_GET_SUMMARY_PENILAIAN_TAHUNAN_DINAS_TAB_GURU =
  'API_GET_SUMMARY_PENILAIAN_TAHUNAN_DINAS_TAB_GURU'

export function useApiGetCountPenilaianTahunanDinasTabGuru(
  params: TRequestPenilaianTahunanCount,
  opts?: UQO<TResponsePenilaianTahunanCount>
) {
  const skpYear = params?.year || undefined

  return useQueryApi<TResponsePenilaianTahunanCount>(
    `${apiPaths.guruPenilaianTahunanPltKsDinas}/count`,
    {
      axiosConfig: { params: { skp_year: skpYear } },
      queryConfig: { useErrorBoundary: false, ...opts },
      queryKey: [API_GET_COUNT_PENILAIAN_TAHUNAN_DINAS_TAB_GURU, skpYear],
    }
  )
}

export function useApiGetListPenilaianTahunanDinasTabGuru(
  params: TRequestListPenilaianTahunan,
  opts?: UQO<TResponseListPenilaianTahunan>
) {
  const skpYear = params?.year || undefined
  const statusPengiriman = params?.statusPengiriman || undefined

  return useQueryApi<TResponseListPenilaianTahunan>(
    apiPaths.guruPenilaianTahunanPltKsDinas,
    {
      axiosConfig: { params: { skp_year: skpYear, statusPengiriman } },
      queryConfig: { useErrorBoundary: false, ...opts },
      queryKey: [
        API_GET_LIST_PENILAIAN_TAHUNAN_DINAS_TAB_GURU,
        skpYear,
        statusPengiriman,
      ],
    }
  )
}

export function useApiGetSummaryPenilaianTahunanDinasTabGuru(
  params: TRequestSummaryPenilaianTahunan,
  opts?: UQO<TResponseSummaryPenilaianTahunan>
) {
  const skpYear = params?.year || undefined

  return useQueryApi<TResponseSummaryPenilaianTahunan>(
    `${apiPaths.guruPenilaianTahunanPltKsDinas}/summary`,
    {
      axiosConfig: { params: { skp_year: skpYear } },
      queryConfig: { useErrorBoundary: false, ...opts },
      queryKey: [API_GET_SUMMARY_PENILAIAN_TAHUNAN_DINAS_TAB_GURU, skpYear],
    }
  )
}

export function useApiPatchOverridePenilaianTahunanDinasTabGuru(
  params: TRequestOverridePenilaianTahunan,
  opts?: UseMutationOptions<
    TResponseOverridePenilaianTahunan,
    null,
    TRequestPayloadOverridePenilaianTahunan
  >
) {
  const skpYear = params?.year || undefined
  return useMutationApi(`${apiPaths.guruPenilaianTahunanPltKsDinas}/override`, {
    axiosConfig: { params: { skp_year: skpYear }, method: 'PATCH' },
    mutationConfig: { useErrorBoundary: false, ...opts },
  })
}

export function useApiPostKirimPenilaianTahunanDinasTabGuru(
  params: TRequestKirimPenilaianTahunan,
  opts?: UseMutationOptions<
    TResponseKirimPenilaianTahunan,
    null,
    TRequestPayloadKirimPenilaianTahunan
  >
) {
  const skpYear = params?.year || undefined
  return useMutationApi(apiPaths.guruPenilaianTahunanPltKsDinas, {
    axiosConfig: { params: { skp_year: skpYear }, method: 'POST' },
    mutationConfig: { useErrorBoundary: false, ...opts },
  })
}
